import { ConversationsProvider } from "./conversations";

export default function Contexts({ children }) {
  return <ConversationsProvider>{children}</ConversationsProvider>;
}
